export const VALUE = "value";
export const CHECKED = "checked";

export const TEXT = "text";

export const INPUT = "input";
export const SELECT = "select";
export const LIST = "list";
export const CHECKBOX = "checkbox";
export const RADIO = "radio";
export const BTN = "button";
